// TODO: check if it's possible to inject c3 in angular
var c3 = require('c3');
/*
    TODO: Enable filtering by:
    - Group
    - Dates
*/
export default function gtExercisesDistributionController(endpoint, Restangular, $auth, $window, $scope) {
    var centerId = $window.localStorage.getItem('center_id');
    var url = endpoint + '/centers/' + centerId + '/dashboard/ecg_exercises_per_group?';

    function getUrl() {
        var args = [];
        if ($scope.from) {
            args.push('from=' + $scope.from);
        }
        if ($scope.to) {
            args.push('to=' + $scope.to);
        }
        if ($scope.selected.group) {
            args.push('group_id=' + $scope.selected.group.id);
        }
        return url + args.join('&');
    }

    var chart;
    function loadChart() {
        if (chart) {
            $auth.validateToken()
                .then(function() {
                    chart.unload();
                    chart.load({
                        url: getUrl(),
                        headers: $auth.retrieveData('auth_headers')
                    });
                });
        } else {
            $auth.validateToken()
                .then(function() {
                    chart = c3.generate({
                        bindto: '#chart',
                        data: {
                            url: getUrl(),
                            headers: $auth.retrieveData('auth_headers'),
                            type: 'pie'
                        }
                    });
                })
        }
    }

    $scope.$watch('from', function(newFrom) {
        loadChart();
    });

    $scope.$watch('to', function(newTo) {
        loadChart();
    });

    $scope.$watch('selected.group', function(newGroup) {
        loadChart();
    });

    $scope.groups = Restangular.all('groups').getList().$object;
    $scope.selected = {};
};

gtExercisesDistributionController.$inject = ['endpoint', 'Restangular', '$auth', '$window', '$scope'];



// WEBPACK FOOTER //
// ./js/stats/gtExercisesDistributionController.js